module.exports = __webpack_public_path__ + "static/img/007城市名片7.1525b78.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/007城市名片7.jpg
// module id = BwGT
// module chunks = 0